/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoutedEligibilityInsuranceContext
 */
export interface RoutedEligibilityInsuranceContext {
    /**
     * 
     */
    payor_id: string;
    /**
     * 
     */
    payor_name?: string;
    /**
     * 
     */
    type: RoutedEligibilityInsuranceContextTypeEnum;
    /**
     * 
     */
    state?: string;
}


/**
 * @export
 */
export const RoutedEligibilityInsuranceContextTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay',
} as const;
export type RoutedEligibilityInsuranceContextTypeEnum = typeof RoutedEligibilityInsuranceContextTypeEnum[keyof typeof RoutedEligibilityInsuranceContextTypeEnum];


/**
 * Check if a given object implements the RoutedEligibilityInsuranceContext interface.
 */
export function instanceOfRoutedEligibilityInsuranceContext(value: object): value is RoutedEligibilityInsuranceContext {
    if (!('payor_id' in value) || value['payor_id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function RoutedEligibilityInsuranceContextFromJSON(json: any): RoutedEligibilityInsuranceContext {
    return RoutedEligibilityInsuranceContextFromJSONTyped(json, false);
}

export function RoutedEligibilityInsuranceContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoutedEligibilityInsuranceContext {
    if (json == null) {
        return json;
    }
    return {
        
        'payor_id': json['payor_id'],
        'payor_name': json['payor_name'] == null ? undefined : json['payor_name'],
        'type': json['type'],
        'state': json['state'] == null ? undefined : json['state'],
    };
}

export function RoutedEligibilityInsuranceContextToJSON(json: any): RoutedEligibilityInsuranceContext {
    return RoutedEligibilityInsuranceContextToJSONTyped(json, false);
}

export function RoutedEligibilityInsuranceContextToJSONTyped(value?: RoutedEligibilityInsuranceContext | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payor_id': value['payor_id'],
        'payor_name': value['payor_name'],
        'type': value['type'],
        'state': value['state'],
    };
}

